import ProposalPage from './ProposalPage';
export default ProposalPage;